import React, { FC } from 'react';
import styled from 'styled-components';

import BaseCard from '@ui/atoms/BaseCard';
import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import Pill from '@ui/atoms/Pill';

import theme from '@theme/FolxTheme';

export interface IIntakeStepCard {
	altText: string;
	description: string;
	image: string;
	timeUnits: string;
	timeUpperBound?: number;
	timeLowerBound?: number;
	title: string;
}

interface IIntakeStepCardProps extends IIntakeStepCard {
	stepNumber: number;
}

const IntakeCard = styled(BaseCard)`
	height: 29rem;
	width: 25rem;
	padding: ${theme.spacing.md};
	text-align: center;

	@media ${theme.responsive.breakpoints.tablet} {
		width: 26.5rem;
	}
`;

const IntakeImageContainer = styled.div`
	height: 12.5rem;
	width: 100%;
	position: relative;
	margin-bottom: ${theme.spacing.lg};
`;

const IntakeImage = styled.img`
	height: 100%;
	width: 100%;
	border-radius: ${theme.radius.smmd};
	object-fit: contain;
`;

const IntakePillContainer = styled.div`
	bottom: -${theme.spacing.sm};
	display: flex;
	justify-content: center;
	position: absolute;
	width: 100%;
`;

const IntakePill = styled(Pill)`
	min-width: 13rem;
	padding: ${theme.spacing.xs} ${theme.spacing.smmd};
	width: auto;
`;

const IntakeStepCard: FC<IIntakeStepCardProps> = ({
	altText,
	description,
	image,
	stepNumber,
	timeUnits,
	timeUpperBound = -1,
	timeLowerBound = -1,
	title,
}) => {
	const lowerBoundTitle = timeLowerBound >= 0 ? `${timeLowerBound}-` : '';
	const timePillTitle =
		timeUpperBound >= 0 ? `${lowerBoundTitle}${timeUpperBound} ${timeUnits}` : timeUnits;
	const timePill = (
		<IntakePill color="yellow" variant="fineprintBold" title={timePillTitle.toUpperCase()} />
	);

	return (
		<IntakeCard borderless bgColor="white" radius="xl">
			<IntakeImageContainer>
				<IntakeImage src={image} alt={altText} />
				<IntakePillContainer>{timePill}</IntakePillContainer>
			</IntakeImageContainer>
			<FlexColumn gap="xssm">
				<BasicText>
					{stepNumber}. {title}
				</BasicText>
				<BasicText variant="fineprint">{description}</BasicText>
			</FlexColumn>
		</IntakeCard>
	);
};

export default styled(IntakeStepCard)``;
